<div class="color-bar"></div>

<div class="conteudo shadow-sm">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <button pButton class="p-button-sm p-button-danger float-left" icon="fas fa-reply" (click)="voltar()"></button>
        <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right" type="button"
          (click)="exportExcel()">
          <i class="fa fa-download mr-1"></i>Export Excel
        </button>
      </div>
    </div>
  </div>
</div>
  <div class="container-fluid">
    <p-table #dt id="principal" *ngIf="registros?.length > 0" [loading]="loading" [columns]="columns" [value]="registros" class="style"
      styleClass="p-datatable-striped p-datatable-sm mt-4" [rowHover]="true" [autoLayout]="true" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th class="text-center" [translate]="getTranslate(col.header)">
              {{col.header}}
              <!-- <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" /> -->
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-registros let-columns="columns" let-rowIndex="rowIndex">
        <tr>
          <ng-container *ngFor="let col of columns">
            <td class="text-center">
              {{ registros[col.field] }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
